export var MediaType;
(function (MediaType) {
    MediaType["GALLERY"] = "GALLERY";
    MediaType["ICON"] = "ICON";
})(MediaType || (MediaType = {}));
export var MediaSource;
(function (MediaSource) {
    MediaSource["IPFS_IMG"] = "IPFS_IMG";
    MediaSource["VIMEO"] = "VIMEO";
    MediaSource["YOUTUBE"] = "YOUTUBE";
    MediaSource["IPFS_VID"] = "IPFS_VID";
})(MediaSource || (MediaSource = {}));
export const EditorContentOverride = '%OVERRIDE@EDITOR@MARKDOWN%';
export const CreateNewWikiSlug = '/*CREATE+NEW+WIKI*/';
export var CommonMetaIds;
(function (CommonMetaIds) {
    CommonMetaIds["REFERENCES"] = "references";
    // other info
    CommonMetaIds["WEBSITE"] = "website";
    CommonMetaIds["CONTRACT_URL"] = "contract_url";
    // social Links
    CommonMetaIds["EMAIL_URL"] = "email_url";
    CommonMetaIds["FACEBOOK_PROFILE"] = "facebook_profile";
    CommonMetaIds["INSTAGRAM_PROFILE"] = "instagram_profile";
    CommonMetaIds["TWITTER_PROFILE"] = "twitter_profile";
    CommonMetaIds["LINKEDIN_PROFILE"] = "linkedin_profile";
    CommonMetaIds["YOUTUBE_PROFILE"] = "youtube_profile";
    CommonMetaIds["DISCORD_PROFILE"] = "discord_profile";
    CommonMetaIds["REDDIT_URL"] = "reddit_profile";
    CommonMetaIds["TELEGRAM_URL"] = "telegram_profile";
    CommonMetaIds["GITHUB_URL"] = "github_profile";
    CommonMetaIds["COIN_MARKET_CAP"] = "coinmarketcap_url";
    CommonMetaIds["COINGECKO_PROFILE"] = "coingecko_profile";
    CommonMetaIds["OPENSEA_PROFILE"] = "opensea_profile";
    CommonMetaIds["MEDIUM_PROFILE"] = "medium_profile";
    // Explorers
    CommonMetaIds["ETHERSCAN_PROFILE"] = "etherscan_profile";
    CommonMetaIds["ARBISCAN_PROFILE"] = "arbiscan_profile";
    CommonMetaIds["POLYGONSCAN_PROFILE"] = "polygonscan_profile";
    CommonMetaIds["BSCSCAN_PROFILE"] = "bscscan_profile";
    CommonMetaIds["OPTIMISTIC_ETHERSCAN_PROFILE"] = "optimistic_etherscan_profile";
})(CommonMetaIds || (CommonMetaIds = {}));
export const WikiPossibleSocialsList = [
    // other info
    CommonMetaIds.WEBSITE,
    CommonMetaIds.CONTRACT_URL,
    // social Links
    CommonMetaIds.EMAIL_URL,
    CommonMetaIds.FACEBOOK_PROFILE,
    CommonMetaIds.INSTAGRAM_PROFILE,
    CommonMetaIds.TWITTER_PROFILE,
    CommonMetaIds.LINKEDIN_PROFILE,
    CommonMetaIds.YOUTUBE_PROFILE,
    CommonMetaIds.REDDIT_URL,
    CommonMetaIds.TELEGRAM_URL,
    CommonMetaIds.DISCORD_PROFILE,
    CommonMetaIds.GITHUB_URL,
    CommonMetaIds.COIN_MARKET_CAP,
    CommonMetaIds.COINGECKO_PROFILE,
    CommonMetaIds.OPENSEA_PROFILE,
    CommonMetaIds.MEDIUM_PROFILE,
    // Explorers
    CommonMetaIds.ETHERSCAN_PROFILE,
    CommonMetaIds.ARBISCAN_PROFILE,
    CommonMetaIds.POLYGONSCAN_PROFILE,
    CommonMetaIds.BSCSCAN_PROFILE,
    CommonMetaIds.OPTIMISTIC_ETHERSCAN_PROFILE,
];
export var ValidatorCodes;
(function (ValidatorCodes) {
    ValidatorCodes["VALID_WIKI"] = "VALID_WIKI";
    ValidatorCodes["ID"] = "ID_ERROR";
    ValidatorCodes["LANGUAGE"] = "LANGUAGE_ERROR";
    ValidatorCodes["USER"] = "USER_ERROR";
    ValidatorCodes["WORDS"] = "WORD_COUNT_ERROR";
    ValidatorCodes["CATEGORY"] = "CATEGORY_ERROR";
    ValidatorCodes["SUMMARY"] = "SUMMARY_ERROR";
    ValidatorCodes["IMAGE"] = "IMAGE_ERROR";
    ValidatorCodes["TAG"] = "TAG_ERROR";
    ValidatorCodes["URL"] = "EXTERNAL_URL_ERROR";
    ValidatorCodes["METADATA"] = "METADATA_ERROR";
    ValidatorCodes["MEDIA"] = "MEDIA_ERROR";
    ValidatorCodes["GLOBAL_RATE_LIMIT"] = "GLOBAL_RATE_LIMIT";
    ValidatorCodes["ID_ERROR"] = "ID_ERROR";
    ValidatorCodes["LINKED_WIKIS"] = "LINKED_WIKIS";
    ValidatorCodes["EVENTS"] = "EVENTS_ERROR";
})(ValidatorCodes || (ValidatorCodes = {}));
export var EditSpecificMetaIds;
(function (EditSpecificMetaIds) {
    EditSpecificMetaIds["PREVIOUS_CID"] = "previous_cid";
    EditSpecificMetaIds["COMMIT_MESSAGE"] = "commit-message";
    EditSpecificMetaIds["WORDS_CHANGED"] = "words-changed";
    EditSpecificMetaIds["PERCENT_CHANGED"] = "percent-changed";
    EditSpecificMetaIds["BLOCKS_CHANGED"] = "blocks-changed";
    EditSpecificMetaIds["WIKI_SCORE"] = "wiki-score";
})(EditSpecificMetaIds || (EditSpecificMetaIds = {}));
var LanguagesValuesEnum;
(function (LanguagesValuesEnum) {
    LanguagesValuesEnum["SPANISH"] = "Espa\u00F1ol";
    LanguagesValuesEnum["ENGLISH"] = "English";
    LanguagesValuesEnum["CHINESE"] = "\u4E2D\u6587";
    LanguagesValuesEnum["KOREAN"] = "\uD55C\uAD6D\uC5B4";
})(LanguagesValuesEnum || (LanguagesValuesEnum = {}));
export var LanguagesISOEnum;
(function (LanguagesISOEnum) {
    LanguagesISOEnum["EN"] = "en";
    LanguagesISOEnum["ES"] = "es";
    LanguagesISOEnum["ZH"] = "zh";
    LanguagesISOEnum["KO"] = "ko";
})(LanguagesISOEnum || (LanguagesISOEnum = {}));
export const Languages = {
    en: LanguagesValuesEnum.ENGLISH,
    es: LanguagesValuesEnum.SPANISH,
    zh: LanguagesValuesEnum.CHINESE,
    ko: LanguagesValuesEnum.KOREAN,
};
export var LinkedWikiKey;
(function (LinkedWikiKey) {
    LinkedWikiKey["FOUNDER"] = "founders";
    LinkedWikiKey["BLOCKCHAIN"] = "blockchains";
})(LinkedWikiKey || (LinkedWikiKey = {}));
export var EventType;
(function (EventType) {
    EventType["CREATED"] = "CREATED";
    EventType["DEFAULT"] = "DEFAULT";
})(EventType || (EventType = {}));
export const whiteListedDomains = [
    'youtube.com/watch',
    'youtu.be',
    'vimeo.com',
    'alpha.everipedia.org/wiki',
    'beta.everipedia.org/wiki',
    'iq.wiki/wiki',
    'ipfs.everipedia.org/ipfs',
];
export const whiteListedLinkNames = ['YOUTUBE@VID', 'DUNE@EMBED'];
//# sourceMappingURL=data:application/json;base64,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